import { Component, OnInit } from '@angular/core';
import { PostService } from "../../Services/post.service"
import { InventoryService } from "../../Services/inventory.service"

import {bikeInventory} from '../../shared/interfaces/bikeInventory.interface';

@Component({
  selector: 'app-bikes',
  templateUrl: './bikes.component.html',
  styleUrls: ['./bikes.component.css']
})
export class BikesComponent implements OnInit {
  bikesSponsored: bikeInventory[] = [];
  bikesRequired: bikeInventory[] = [];
  constructor(private postService: PostService, private inventoryService: InventoryService) {

    this.inventoryService.getRequiredBikes().subscribe(books => {
      this.bikesRequired = books;
    });

    this.inventoryService.getDonnatedBikes().subscribe(books => {
      this.bikesSponsored = books;
    });

  }
  ngOnInit() {
  }

}



// WEBPACK FOOTER //
// ./src/app/Components/bikes/bikes.component.ts